import { createAsyncAction, createStandardAction } from 'typesafe-actions'
import {
  SaleOrderCustomerListReq,
  SaleOrderCustomerListRes,
  CreateSaleOrderCustomerReq,
  ActionSaleOrderCustomerRes,
  UpdateSaleOrderCustomerReq,
  DeleteSaleOrderCustomerReq,
  SaleOrderCustomerDetailReq,
  SaleOrderCustomerDetailRes,
  SaleOrderListReq,
  SaleOrderListRes,
} from './types'

export const getSaleOrderCustomerListAction = createAsyncAction(
  'SALE_ORDER_CUSTOMER/GET_SALE_ORDER_CUSTOMER_LIST_REQ',
  'SALE_ORDER_CUSTOMER/GET_SALE_ORDER_CUSTOMER_LIST_SUCCESS',
  'SALE_ORDER_CUSTOMER/GET_SALE_ORDER_CUSTOMER_LIST_FAILURE',
)<SaleOrderCustomerListReq, SaleOrderCustomerListRes, Error>()

export const getSaleOrderCustomerDetailAction = createAsyncAction(
  'SALE_ORDER_CUSTOMER/GET_SALE_ORDER_CUSTOMER_DETAIL_REQ',
  'SALE_ORDER_CUSTOMER/GET_SALE_ORDER_CUSTOMER_DETAIL_SUCCESS',
  'SALE_ORDER_CUSTOMER/GET_SALE_ORDER_CUSTOMER_DETAIL_FAILURE',
)<SaleOrderCustomerDetailReq, SaleOrderCustomerDetailRes, Error>()

export const createSaleOrderCustomerAction = createAsyncAction(
  'SALE_ORDER_CUSTOMER/CREATE_SALE_ORDER_CUSTOMER_REQ',
  'SALE_ORDER_CUSTOMER/CREATE_SALE_ORDER_CUSTOMER_SUCCESS',
  'SALE_ORDER_CUSTOMER/CREATE_SALE_ORDER_CUSTOMER_FAILURE',
)<CreateSaleOrderCustomerReq, ActionSaleOrderCustomerRes, Error>()

export const updateSaleOrderCustomerAction = createAsyncAction(
  'SALE_ORDER_CUSTOMER/UPDATE_SALE_ORDER_CUSTOMER_REQ',
  'SALE_ORDER_CUSTOMER/UPDATE_SALE_ORDER_CUSTOMER_SUCCESS',
  'SALE_ORDER_CUSTOMER/UPDATE_SALE_ORDER_CUSTOMER_FAILURE',
)<UpdateSaleOrderCustomerReq, ActionSaleOrderCustomerRes, Error>()

export const deleteSaleOrderCustomerAction = createAsyncAction(
  'SALE_ORDER_CUSTOMER/DELETE_SALE_ORDER_CUSTOMER_REQ',
  'SALE_ORDER_CUSTOMER/DELETE_SALE_ORDER_CUSTOMER_SUCCESS',
  'SALE_ORDER_CUSTOMER/DELETE_SALE_ORDER_CUSTOMER_FAILURE',
)<DeleteSaleOrderCustomerReq, ActionSaleOrderCustomerRes, Error>()

export const getAllSaleOrderCustomerListAction = createAsyncAction(
  'SALE_ORDER_CUSTOMER/GET_ALL_SALE_ORDER_CUSTOMER_LIST_REQ',
  'SALE_ORDER_CUSTOMER/GET_ALL_SALE_ORDER_CUSTOMER_LIST_SUCCESS',
  'SALE_ORDER_CUSTOMER/GET_ALL_SALE_ORDER_CUSTOMER_LIST_FAILURE',
)<SaleOrderCustomerListReq, SaleOrderCustomerListRes, Error>()

export const getSaleOrderListAction = createAsyncAction(
  'SALE_ORDER_CUSTOMER/GET_SALE_ORDER_LIST_REQ',
  'SALE_ORDER_CUSTOMER/GET_SALE_ORDER_LIST_SUCCESS',
  'SALE_ORDER_CUSTOMER/GET_SALE_ORDER_LIST_FAILURE',
)<SaleOrderListReq, SaleOrderListRes, Error>()

export const clearEventAction = createStandardAction('SALE_ORDER_CUSTOMER/CLEAR_EVENT')<void>()
